
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./display-single-rel.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/display-single-rel/display-single-rel.component.scss
// module id = 318
// module chunks = 0 1